import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const KEY = "parabolum-theme";
const ThemeCtx = createContext({ theme: "dark", toggle: () => {}, setTheme: () => {} });

// Parabolum is dark by default. Light mode exists but is the experimental
// override — we deliberately do NOT honour `prefers-color-scheme` on first
// visit so the brand experience is always cinematic on arrival.
function getInitial() {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch (e) {
    /* ignore */
  }
  return "dark";
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState("dark");

  // resolve initial theme on mount (avoids SSR mismatch)
  useEffect(() => {
    setThemeState(getInitial());
  }, []);

  const setTheme = useCallback((t) => {
    setThemeState(t);
    try {
      localStorage.setItem(KEY, t);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const toggle = useCallback(() => {
    setThemeState((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      try {
        localStorage.setItem(KEY, next);
      } catch (e) {
        /* ignore */
      }
      return next;
    });
  }, []);

  return (
    <ThemeCtx.Provider value={{ theme, toggle, setTheme }}>{children}</ThemeCtx.Provider>
  );
}

export const useTheme = () => useContext(ThemeCtx);
